import { render, staticRenderFns } from "./TransferEntryDetail.vue?vue&type=template&id=ff951f2a&"
import script from "./TransferEntryDetail.vue?vue&type=script&lang=js&"
export * from "./TransferEntryDetail.vue?vue&type=script&lang=js&"
import style0 from "./TransferEntryDetail.vue?vue&type=style&index=0&id=ff951f2a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports